import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TreeAdapter } from "@app/shared/util/tree-adapter.utils";
import { TranslateService } from "@ngx-translate/core";
import { ContextMenu } from "primeng/contextmenu";
import { TreeModel } from "@components/tree/tree.model";
import { TreeNode } from "primeng/api";

@Component({
    selector: 'app-file-tree',
    templateUrl: './file-tree.component.html',
    styleUrls: ['./file-tree.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FileTreeComponent implements OnInit {
    @ViewChild("cm", {static: false}) contextMenu: ContextMenu;

    @Input()
    displayField: string;
    @Input()
    label = '';
    @Input()
    labelClass = {};
    @Input()
    hasContextMenu = false;
    @Input()
    contextMenuItems = [];

    @Output()
    onNewFolder = new EventEmitter<any>();
    @Output()
    onLinkPath = new EventEmitter<any>();
    @Output()
    onDownloadFile = new EventEmitter<any>();
    @Output()
    onCardinalityChange = new EventEmitter<any>();

    node: any;

    _items = [];


    constructor(private treeAdapter: TreeAdapter,
                private translateService: TranslateService) {
    }

    ngOnInit() {
    }


    onContextMenuOpen(event: { node: TreeModel, originalEvent: PointerEvent }) {
        this.contextMenuItems = this.buildContextMenuItems(event.node);
        event.originalEvent.preventDefault();
        event.originalEvent.stopPropagation();
        this.contextMenu.show(event.originalEvent);
    }

    private buildContextMenuItems(node: TreeModel) {
        let contextMenuItems = [];
        if (node.isTopLevel) {
            contextMenuItems = [
                {
                    label: this.translateService.instant('admin.tools.details.documentsPage.fileManager.contextMenu.addLink'),
                    icon: 'fa fa-upload',
                    command: (event) => this.editPath(this.node)
                },
                {
                    label: this.getCardinalityLabel(this.node.data),
                    icon: this.getCardinalityIcon(this.node.data),
                    command: (event) => this.cardinalityChange(this.node)
                }
            ];
        } else if (!node.isFolder && !node.isSubfolder) {
            contextMenuItems = [
                {
                    label: this.translateService.instant('admin.tools.details.documentsPage.fileManager.contextMenu.downloadFile'),
                    icon: 'fa fa-download',
                    command: (event) => this.viewFile(this.node)
                }
            ];
        } else {
            contextMenuItems = [
                {
                    label: this.translateService.instant('admin.tools.details.documentsPage.fileManager.contextMenu.noAction'),
                    icon: 'fa fa-solid fa-ban',
                }
            ];
        }
        return contextMenuItems;
    }

    private getCardinalityLabel(element) {
        return element.isMandatory ?
            this.translateService.instant('admin.tools.details.documentsPage.fileManager.contextMenu.markAsOptional') :
            this.translateService.instant('admin.tools.details.documentsPage.fileManager.contextMenu.markAsMandatory');
    }

    private getCardinalityIcon(element) {
        return element.isMandatory ? 'fa fa-folder-o' : 'fa fa-folder';
    }

    private viewFile(node) {
        this.onDownloadFile.emit(node);
    }

    private editPath(node) {
        this.onLinkPath.emit(node);
    }

    private cardinalityChange(node) {
        this.onCardinalityChange.emit(node)
    }

    get items() {
        return this._items;
    }

    @Input()
    set items(items) {
        this._items = this.treeAdapter.adaptDocumentsToTree(items, this.displayField);
    }

}
